import dayjs from "dayjs";
import { getHotelPixelConfig, getHotelPixelConfigByName } from "./sojernPixelConfig";

export const initSojernPixel = () => {
  if (typeof window !== "undefined" && !window.sjn) {
    const script = document.createElement("script");
    script.src = "https://static.sojern.com/sdk/latest/sojern.min.js";
    script.async = true;
    document.head.appendChild(script);
    
    window.sjn = window.sjn || function() {
      (window.sjn.q = window.sjn.q || []).push(arguments);
    };
  }
};

export const trackSojernSearch = (data) => {
  if (typeof window !== "undefined" && window.sjn) {
    const {
      checkInDate,
      checkOutDate,
      hotelId,
      hotelName,
      city,
      state,
      country,
      numberOfRooms,
      numberOfTravelers,
      nearestAirport
    } = data;
    
    // Get hotel-specific pixel configuration - try ID first, then name as fallback
    let pixelConfig = hotelId ? getHotelPixelConfig(hotelId) : null;
    if (!pixelConfig && hotelName) {
      pixelConfig = getHotelPixelConfigByName(hotelName);
    }
    
    if (!pixelConfig || !pixelConfig.search || !pixelConfig.advertiserId) {
      console.warn(`No search pixel configuration found for hotel: ${hotelId || hotelName}`);
      return;
    }
    
    const formattedCheckIn = checkInDate ? dayjs(checkInDate).format("YYYY-MM-DD") : "";
    const formattedCheckOut = checkOutDate ? dayjs(checkOutDate).format("YYYY-MM-DD") : "";
    
    window.sjn("initAndFire", 
      "advertiser", 
      pixelConfig.advertiserId, 
      "search", 
      {
        context: { vertical: "hotel" },
        params: {
          pixelID: pixelConfig.search,
          checkInDate: formattedCheckIn,
          checkOutDate: formattedCheckOut,
          city: city || pixelConfig.city || "",
          state: state || pixelConfig.state || "",
          country: country || pixelConfig.country || "IN",
          property: pixelConfig.hotelName || hotelName || "",
          numberOfRooms: numberOfRooms || 0,
          numberOfTravelers: numberOfTravelers || 0,
          nearestAirport: nearestAirport || pixelConfig.nearestAirport || ""
        }
      }
    );
    
    console.log(`Sojern search pixel fired for ${pixelConfig.hotelName} (ID: ${hotelId}) with pixel ID ${pixelConfig.search}`);
  }
};

export const trackSojernCart = (data) => {
  if (typeof window !== "undefined" && window.sjn) {
    const {
      checkInDate,
      checkOutDate,
      hotelId,
      hotelName,
      city,
      state,
      country,
      numberOfRooms,
      numberOfTravelers,
      nearestAirport,
      price,
      currency
    } = data;
    
    // Get hotel-specific pixel configuration - try ID first, then name as fallback
    let pixelConfig = hotelId ? getHotelPixelConfig(hotelId) : null;
    if (!pixelConfig && hotelName) {
      pixelConfig = getHotelPixelConfigByName(hotelName);
    }
    
    if (!pixelConfig || !pixelConfig.cart || !pixelConfig.advertiserId) {
      console.warn(`No cart pixel configuration found for hotel: ${hotelId || hotelName}`);
      return;
    }
    
    const formattedCheckIn = checkInDate ? dayjs(checkInDate).format("YYYY-MM-DD") : "";
    const formattedCheckOut = checkOutDate ? dayjs(checkOutDate).format("YYYY-MM-DD") : "";
    
    window.sjn("initAndFire", 
      "advertiser", 
      pixelConfig.advertiserId, 
      "shoppingCart", 
      {
        context: { vertical: "hotel" },
        params: {
          pixelID: pixelConfig.cart,
          checkInDate: formattedCheckIn,
          checkOutDate: formattedCheckOut,
          city: city || pixelConfig.city || "",
          state: state || pixelConfig.state || "",
          country: country || pixelConfig.country || "IN",
          property: pixelConfig.hotelName || hotelName || "",
          numberOfRooms: numberOfRooms || 0,
          numberOfTravelers: numberOfTravelers || 0,
          price: price || 0,
          currency: currency || "INR",
          nearestAirport: nearestAirport || pixelConfig.nearestAirport || ""
        }
      }
    );
    
    console.log(`Sojern cart pixel fired for ${pixelConfig.hotelName} (ID: ${hotelId}) with pixel ID ${pixelConfig.cart}`);
  }
};

export const trackSojernConversion = (data) => {
  if (typeof window !== "undefined" && window.sjn) {
    const {
      checkInDate,
      checkOutDate,
      hotelId,
      hotelName,
      city,
      state,
      country,
      numberOfRooms,
      numberOfTravelers,
      discountCode,
      price,
      confirmationNumber,
      currency,
      nearestAirport
    } = data;
    
    // Get hotel-specific pixel configuration - try ID first, then name as fallback
    let pixelConfig = hotelId ? getHotelPixelConfig(hotelId) : null;
    if (!pixelConfig && hotelName) {
      pixelConfig = getHotelPixelConfigByName(hotelName);
    }
    
    if (!pixelConfig || !pixelConfig.conversion || !pixelConfig.advertiserId) {
      console.warn(`No conversion pixel configuration found for hotel: ${hotelId || hotelName}`);
      return;
    }
    
    const formattedCheckIn = checkInDate ? dayjs(checkInDate).format("YYYY-MM-DD") : "";
    const formattedCheckOut = checkOutDate ? dayjs(checkOutDate).format("YYYY-MM-DD") : "";
    
    window.sjn("initAndFire", 
      "advertiser", 
      pixelConfig.advertiserId, 
      "conversion", 
      {
        context: { vertical: "hotel" },
        params: {
          pixelID: pixelConfig.conversion,
          checkInDate: formattedCheckIn,
          checkOutDate: formattedCheckOut,
          city: city || pixelConfig.city || "",
          state: state || pixelConfig.state || "",
          country: country || pixelConfig.country || "IN",
          property: pixelConfig.hotelName || hotelName || "",
          numberOfRooms: numberOfRooms || 0,
          numberOfTravelers: numberOfTravelers || 0,
          discountCode: discountCode || "",
          price: price || 0,
          confirmationNumber: confirmationNumber ? String(confirmationNumber) : "",
          currency: currency || "INR",
          nearestAirport: nearestAirport || pixelConfig.nearestAirport || ""
        }
      }
    );
    
    console.log(`Sojern conversion pixel fired for ${pixelConfig.hotelName} (ID: ${hotelId}) with pixel ID ${pixelConfig.conversion}`);
  }
};